<main>
  <div class="min-h-screen bg-bg-base">

    <!-- ══════════════ STICKY HEADER BAR ══════════════ -->
    <div class="bg-surface-elevated/90 backdrop-blur-md border-b border-border sticky top-16 z-40 shadow-sm">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">

        <!-- Row 1: Title + Controls -->
        <div class="flex items-center justify-between gap-3 flex-wrap">

          <!-- Title -->
          <div class="min-w-0">
            <h1 class="text-text-primary text-lg font-bold leading-tight">{{ 'allProperties.title' | translate }}</h1>
            <p class="text-text-muted text-xs mt-0.5">
              {{ 'allProperties.foundPrefix' | translate }}
              <span class="font-bold text-primary">{{ totalResults }}</span>
              {{ 'allProperties.foundSuffix' | translate }}
            </p>
          </div>

          <!-- Controls -->
          <div class="flex items-center gap-2 flex-wrap">

            <!-- Purpose toggle -->
            <div class="hidden sm:flex items-center gap-1 bg-surface p-1 rounded-xl ring-1 ring-border">
              <button (click)="setPurpose('rent')" [ngClass]="activePurpose === 'rent'
                  ? 'bg-gradient-to-r from-primary to-primary-deep text-white shadow-md shadow-primary-glow/30'
                  : 'text-text-secondary hover:text-text-primary'"
                class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-semibold transition-all">
                <i class="fas fa-key text-xs"></i>
                {{ 'navbar.links.rent' | translate }}
                @if (activePurpose === 'rent') {
                <span class="bg-white/25 text-white text-xs px-1.5 py-0.5 rounded-full font-bold">{{ totalResults
                  }}</span>
                }
              </button>
              <button (click)="setPurpose('sale')" [ngClass]="activePurpose === 'sale'
                  ? 'bg-gradient-to-r from-primary to-primary-deep text-white shadow-md shadow-primary-glow/30'
                  : 'text-text-secondary hover:text-text-primary'"
                class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-semibold transition-all">
                <i class="fas fa-home text-xs"></i>
                {{ 'navbar.links.buy' | translate }}
                @if (activePurpose === 'sale') {
                <span class="bg-white/25 text-white text-xs px-1.5 py-0.5 rounded-full font-bold">{{ totalResults
                  }}</span>
                }
              </button>
            </div>

            <!-- Sort select -->
            <div class="relative">
              <i
                class="fas fa-sort-amount-down absolute start-3 top-1/2 -translate-y-1/2 text-text-muted text-xs pointer-events-none"></i>
              <select
                class="ps-8 pe-7 py-2 bg-surface-elevated border border-border rounded-xl text-sm appearance-none cursor-pointer hover:border-primary/50 focus:border-primary focus:ring-2 focus:ring-primary/20 focus:outline-none transition-all text-text-primary font-medium">
                <option value="recommended">{{ 'allProperties.sort.recommended' | translate }}</option>
                <option value="price-low">{{ 'allProperties.sort.priceLow' | translate }}</option>
                <option value="price-high">{{ 'allProperties.sort.priceHigh' | translate }}</option>
                <option value="newest">{{ 'allProperties.sort.newest' | translate }}</option>
                <option value="rating">{{ 'allProperties.sort.rating' | translate }}</option>
              </select>
              <i
                class="fas fa-chevron-down absolute end-2.5 top-1/2 -translate-y-1/2 text-text-muted text-xs pointer-events-none"></i>
            </div>

            <!-- Filters toggle button -->
            <button (click)="toggleFilters()"
              class="flex items-center gap-2 px-4 py-2 btn btn-primary rounded-xl text-sm font-semibold transition-all">
              <i class="fas fa-sliders-h text-xs"></i>
              {{ showFilters ? ('allProperties.filters.hide' | translate) : ('allProperties.filters.show' | translate)
              }}
            </button>

          </div>
        </div>

        <!-- Mobile purpose toggle -->
        <div class="flex sm:hidden gap-2 mt-3">
          <button (click)="setPurpose('rent')" [ngClass]="activePurpose === 'rent'
              ? 'bg-gradient-to-r from-primary to-primary-deep text-white shadow-md shadow-primary-glow/30'
              : 'bg-surface-elevated text-text-secondary border border-border'"
            class="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl text-sm font-semibold transition-all">
            <i class="fas fa-key text-xs"></i>
            {{ 'navbar.links.rent' | translate }}
          </button>
          <button (click)="setPurpose('sale')" [ngClass]="activePurpose === 'sale'
              ? 'bg-gradient-to-r from-primary to-primary-deep text-white shadow-md shadow-primary-glow/30'
              : 'bg-surface-elevated text-text-secondary border border-border'"
            class="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl text-sm font-semibold transition-all">
            <i class="fas fa-home text-xs"></i>
            {{ 'navbar.links.buy' | translate }}
          </button>
        </div>

      </div>
    </div>
    <!-- / STICKY HEADER BAR -->

    <!-- ══════════════ MAIN CONTENT ══════════════ -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div class="grid grid-cols-1 lg:grid-cols-4 gap-8">

        <!-- ── FILTERS SIDEBAR ── -->
        @if (showFilters) {
        <div class="lg:col-span-1">
          <div class="surface-card p-6 sticky top-24 transition-all">

            <!-- Sidebar header -->
            <div class="flex items-center justify-between mb-6">
              <h3 class="text-sm font-bold text-text-primary tracking-wide flex items-center gap-2">
                <i class="fa-solid fa-sliders text-primary text-sm"></i>
                {{ 'allProperties.filters.title' | translate }}
              </h3>
              <div class="flex items-center gap-2">
                <button (click)="resetFilters()"
                  class="text-xs font-bold text-primary hover:text-primary-deep transition-colors bg-primary/10 hover:bg-primary/20 px-2.5 py-1 rounded-lg border border-primary/20">
                  {{ 'allProperties.filters.reset' | translate }}
                </button>
                <button (click)="toggleFilters()"
                  class="w-7 h-7 flex items-center justify-center rounded-lg text-text-muted hover:text-text-primary hover:bg-surface-elevated transition-all">
                  <i class="fas fa-times text-sm"></i>
                </button>
              </div>
            </div>

            <!-- Filter fields -->
            <div class="space-y-5">

              <!-- Property Type -->
              <div>
                <label class="block text-[10.5px] font-extrabold text-text-muted uppercase tracking-widest mb-2">
                  {{ 'allProperties.filters.propertyType' | translate }}
                </label>
                <div class="relative">
                  <select name="propertyType" [(ngModel)]="activePropertyType" (ngModelChange)="applyFilters()"
                    class="form-input w-full px-3.5 py-2.5 rounded-xl appearance-none cursor-pointer">
                    <option value="all">{{ 'allProperties.filters.allTypes' | translate }}</option>
                    <option value="apartment">{{ 'allProperties.filters.apartment' | translate }}</option>
                    <option value="villa">{{ 'allProperties.filters.villa' | translate }}</option>
                    <option value="studio">{{ 'allProperties.filters.studio' | translate }}</option>
                    <option value="shop">{{ 'allProperties.filters.shop' | translate }}</option>
                    <option value="warehouse">{{ 'allProperties.filters.warehouse' | translate }}</option>
                  </select>
                  <i
                    class="fas fa-chevron-down absolute end-3 top-1/2 -translate-y-1/2 text-text-muted text-xs pointer-events-none"></i>
                </div>
              </div>

              <!-- Price Range -->
              <div>
                <label class="block text-[10.5px] font-extrabold text-text-muted uppercase tracking-widest mb-2">
                  {{ 'allProperties.filters.priceRange' | translate }}
                </label>
                <div class="grid grid-cols-2 gap-2.5">
                  <input type="number" name="minPrice" [(ngModel)]="minPrice" (ngModelChange)="applyFilters()"
                    [placeholder]="'allProperties.filters.minPrice' | translate"
                    class="form-input w-full px-3 py-2.5 rounded-xl" />
                  <input type="number" name="maxPrice" [(ngModel)]="maxPrice" (ngModelChange)="applyFilters()"
                    [placeholder]="'allProperties.filters.maxPrice' | translate"
                    class="form-input w-full px-3 py-2.5 rounded-xl" />
                </div>
              </div>

              <!-- Area Range -->
              <div>
                <label class="block text-[10.5px] font-extrabold text-text-muted uppercase tracking-widest mb-2">
                  {{ 'allProperties.filters.areaRange' | translate }} (m²)
                </label>
                <div class="grid grid-cols-2 gap-2.5">
                  <input type="number" name="minArea" [(ngModel)]="minArea" (ngModelChange)="applyFilters()"
                    [placeholder]="'allProperties.filters.minArea' | translate"
                    class="form-input w-full px-3 py-2.5 rounded-xl" />
                  <input type="number" name="maxArea" [(ngModel)]="maxArea" (ngModelChange)="applyFilters()"
                    [placeholder]="'allProperties.filters.maxArea' | translate"
                    class="form-input w-full px-3 py-2.5 rounded-xl" />
                </div>
              </div>

              <!-- Bedrooms -->
              <div>
                <label class="block text-[10.5px] font-extrabold text-text-muted uppercase tracking-widest mb-2">
                  {{ 'allProperties.filters.bedrooms' | translate }}
                </label>
                <div class="relative">
                  <select name="bedrooms" [(ngModel)]="activeBedrooms" (ngModelChange)="applyFilters()"
                    class="form-input w-full px-3.5 py-2.5 rounded-xl appearance-none cursor-pointer">
                    <option value="any">{{ 'allProperties.filters.anyNumber' | translate }}</option>
                    <option value="0">Studio</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4+</option>
                  </select>
                  <i
                    class="fas fa-chevron-down absolute end-3 top-1/2 -translate-y-1/2 text-text-muted text-xs pointer-events-none"></i>
                </div>
              </div>

              <!-- City -->
              <div>
                <label class="block text-[10.5px] font-extrabold text-text-muted uppercase tracking-widest mb-2">
                  {{ 'allProperties.filters.city' | translate }}
                </label>
                <div class="relative">
                  <select name="city" [(ngModel)]="activeCity" (ngModelChange)="applyFilters()"
                    class="form-input w-full px-3.5 py-2.5 rounded-xl appearance-none cursor-pointer">
                    <option value="all">{{ 'allProperties.filters.allCities' | translate }}</option>
                    <option value="cairo">{{ 'allProperties.filters.cairo' | translate }}</option>
                    <option value="giza">{{ 'allProperties.filters.giza' | translate }}</option>
                    <option value="alex">{{ 'allProperties.filters.alex' | translate }}</option>
                  </select>
                  <i
                    class="fas fa-chevron-down absolute end-3 top-1/2 -translate-y-1/2 text-text-muted text-xs pointer-events-none"></i>
                </div>
              </div>

              <!-- Sort By -->
              <div>
                <label class="block text-[10.5px] font-extrabold text-text-muted uppercase tracking-widest mb-2">
                  {{ 'allProperties.filters.sortBy' | translate }}
                </label>
                <div class="relative">
                  <select name="sortBy" [(ngModel)]="sortBy" (ngModelChange)="changeSort($event)"
                    class="form-input w-full px-3.5 py-2.5 rounded-xl appearance-none cursor-pointer">
                    <option value="newest">{{ 'allProperties.sort.newest' | translate }}</option>
                    <option value="priceLow">{{ 'allProperties.sort.priceLow' | translate }}</option>
                    <option value="priceHigh">{{ 'allProperties.sort.priceHigh' | translate }}</option>
                    <option value="areaLarge">{{ 'allProperties.sort.rating' | translate }}</option>
                  </select>
                  <i
                    class="fas fa-chevron-down absolute end-3 top-1/2 -translate-y-1/2 text-text-muted text-xs pointer-events-none"></i>
                </div>
              </div>

              <!-- Apply button -->
              <button (click)="applyFilters()"
                class="w-full mt-1 px-6 py-3 btn btn-primary text-sm rounded-xl">
                {{ 'allProperties.filters.apply' | translate }}
              </button>

            </div>
          </div>
        </div>
        }
        <!-- / FILTERS SIDEBAR -->

        <!-- ── RESULTS AREA ── -->
        <div [ngClass]="showFilters ? 'lg:col-span-3' : 'lg:col-span-4'">

          <!-- Loading skeletons -->
          @if (isLoading) {
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            @for (item of [1,2,3,4,5,6]; track item) {
            <div class="surface-card rounded-[20px] overflow-hidden flex flex-col h-full">
              <div class="h-[220px] w-full bg-surface-elevated animate-pulse"></div>
              <div class="p-5 flex flex-col flex-1 space-y-4">
                <div class="flex items-center justify-between">
                  <div class="h-3 bg-border rounded-full animate-pulse w-1/4"></div>
                  <div class="h-5 bg-primary/10 rounded-lg animate-pulse w-1/5"></div>
                </div>
                <div class="space-y-2">
                  <div class="h-4 bg-border rounded-full animate-pulse w-full"></div>
                  <div class="h-4 bg-border rounded-full animate-pulse w-2/3"></div>
                </div>
                <div class="h-3 bg-border rounded-full animate-pulse w-1/2"></div>
                <div class="h-px bg-gradient-to-r from-primary/20 to-transparent"></div>
                <div class="flex items-center gap-2">
                  <div class="h-7 bg-primary/10 border border-primary/20 rounded-lg animate-pulse w-16"></div>
                  <div class="h-7 bg-primary/10 border border-primary/20 rounded-lg animate-pulse w-16"></div>
                  <div class="h-7 bg-primary/10 border border-primary/20 rounded-lg animate-pulse w-20"></div>
                </div>
                <div class="flex items-end justify-between pt-4 mt-auto border-t border-border-subtle">
                  <div class="space-y-1.5">
                    <div class="h-6 bg-border rounded-full animate-pulse w-24"></div>
                    <div class="h-3 bg-border-strong rounded-full animate-pulse w-12"></div>
                  </div>
                  <div class="h-6 bg-primary/10 border border-primary/20 rounded-lg animate-pulse w-12"></div>
                </div>
              </div>
            </div>
            }
          </div>
          }

          <!-- Error state -->
          @if (errorMessage && !isLoading) {
          <div class="border border-danger/30 bg-danger/10 rounded-2xl p-8 text-center max-w-md mx-auto my-12 shadow-sm">
            <div class="w-12 h-12 bg-danger/20 rounded-full flex items-center justify-center mx-auto mb-4 border border-danger/30">
              <i class="fas fa-exclamation-circle text-danger text-xl"></i>
            </div>
            <p class="text-text-primary font-bold mb-1">{{ 'allProperties.error' | translate }}</p>
            <p class="text-text-secondary text-sm mb-5">{{ errorMessage }}</p>

            <div class="flex justify-center w-full">
              <button (click)="loadProperties()"
                class="px-5 py-2.5 btn btn-primary font-semibold text-sm rounded-xl">
                {{ 'allProperties.retry' | translate }}
              </button>
            </div>
          </div>
          }
          <!-- Empty state -->
          @if (!isLoading && !errorMessage && properties.length === 0) {
          <div class="surface-card rounded-2xl p-16 text-center max-w-md mx-auto my-12">
            <div class="w-16 h-16 bg-primary/10 border border-primary/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i class="fa-solid fa-building-circle-xmark text-primary text-2xl"></i>
            </div>
            <h3 class="text-text-primary font-bold text-lg mb-2">{{ 'allProperties.noProperties' | translate }}</h3>
            <p class="text-text-secondary text-sm mb-6">{{ 'allProperties.noPropertiesMessage' | translate }}</p>
            <button (click)="resetFilters()"
              class="mx-auto block px-5 py-2.5 btn btn-primary font-semibold text-sm rounded-xl">
              {{ 'allProperties.filters.reset' | translate }}
            </button>
          </div>
          }

          <!-- Properties grid -->
          @if (!isLoading && !errorMessage && properties.length > 0) {
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            @for (property of properties; track property._id) {
            <app-units-card [property]="property" (propertyClick)="onPropertyClick($event)"></app-units-card>
            }
          </div>
          }

        </div>
        <!-- / RESULTS AREA -->

      </div>
    </div>
    <!-- / MAIN CONTENT -->

  </div>
</main>
<!-- <app-buy-unit-details></app-buy-unit-details> -->